import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeInstallPrompt } from './utils/pwaHelpers';

// Debug environment variables (dev only)
if (import.meta.env.DEV) {
  console.log('Environment mode:', import.meta.env.MODE);
  console.log('VITE_FIREBASE_API_KEY:', import.meta.env.VITE_FIREBASE_API_KEY ? '[SET]' : '[MISSING]');
}

// Make sure the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('root');

  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    );
  } else {
    console.error("Root element with id 'root' not found!");
  }
});

// Initialize PWA install prompt (SW registration handled by static sw.js in public/)
initializeInstallPrompt((ready: boolean) => {
  if (ready) {
    localStorage.setItem('pwaInstallReady', 'true');
  }
});